import React from 'react';

import { scaleBand, tickFormat } from 'd3';

import { Marks } from './Marks';
import { AxisBottom } from './AxisBottom';
import { AxisLeft } from './AxisLeft';
import { Graph } from '../generalPlot/Graph';


const margin = {top: 50, left: 70, bottom: 50, right: 20};


export const BarChart = ( {data, yScale, width, height, color, onHover, hovered, title} ) => {
  const fattyAcids = data.map(d => d.fatty_acid).sort();

  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  const x = scaleBand()
    .domain(fattyAcids)
    .range([0, innerWidth])
    .padding(0.1);

  const y = yScale
    .range([innerHeight, 0])
    .nice();
  const formatter = tickFormat(0, 1, 5, "%");

  return (
    <Graph
      width={width}
      height={height}
      margin={margin}
    >
      <text
        className="plot-title"
        x={innerWidth / 2} y={-15} textAnchor="middle">{title}</text>
      <AxisBottom 
        x={x}
        innerHeight={innerHeight}
      />
      <AxisLeft
        y={y}
        innerWidth={innerWidth}
        formatter={formatter}
      />
      <text 
        className="axis-label"
        transform={`translate(-55,${innerHeight/2}) rotate(-90)`}
        textAnchor="middle">Probability / %</text>
      <Marks
        data={data}
        x={x}
        y={y}
        color={color}
        innerHeight={innerHeight}
        onHover={onHover}
        hovered={hovered}
      />
      ))}
    </Graph>
  );
};
